/* FAQ accordions — delegated, covers every .faq-item / .faq-btn / .faq-answer group.
   Open items are siblings within the same wrapper, so only that group is collapsed. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.faq-btn');
  if (!btn) return;
  var item = btn.closest('.faq-item');
  if (!item) return;

  var isOpen = item.classList.contains('open');
  item.parentElement.querySelectorAll('.faq-item.open').forEach(function (el) {
    el.classList.remove('open');
    var openBtn = el.querySelector('.faq-btn');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) item.classList.add('open');
  btn.setAttribute('aria-expanded', String(!isOpen));
});
